import { React, useState, useEffect, useRef } from '../lib/imports';

import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { Image, Input, Spacing, SubmitButton, Text } from '../components';
import { submitUsername } from './actions';
import { useCdnUrl } from './../app/context/config';
import { useDispatch, useSelector } from 'react-redux';

const nameEntryStyles = ({ theme }) => css`
  padding-top: ${theme.spacings.tera};
  margin-left: ${theme.spacings.peta};
  margin-right: ${theme.spacings.peta};
`;
const NameEntryContainer = styled('div')(nameEntryStyles);

const scrollToRef = (ref) => {
  document.getElementById('thLayout').scrollTo(0, ref.current.getBoundingClientRect().bottom);
};

const NameEntry = () => {
  const { strings, onboarding, ui } = useSelector((state) => state);
  const dispatch = useDispatch();
  const { usernameValidationErr, isFetching, resetUserNameAttemptStatus } = onboarding;
  const { hasFetchError } = ui;

  const [username, setUsername] = useState('');
  const inputRef = useRef();
  const executeScroll = () => {
    scrollToRef(inputRef);
  };

  useEffect(() => {
    inputRef.current.focus();
  });

  useEffect(() => {
    if (!hasFetchError && resetUserNameAttemptStatus) {
      dispatch(submitUsername(username));
    }
  }, [hasFetchError, resetUserNameAttemptStatus]);

  const cdnUrl = useCdnUrl();
  const handleUsernameSubmit = () => {
    dispatch(submitUsername(username));
  };

  const errorText = usernameValidationErr
    ? strings['username/usernameLengthError/text']
    : onboarding.errorCode
    ? strings['username/boomError/text'](onboarding.errorCode)
    : '';
  const headerText = strings['username/header/text'];
  const blurbText = strings['username/blurb/text'];
  const buttonText = strings['username/saveButton/text'];

  return (
    <NameEntryContainer>
      <Text lineHeight='22px' size='zetta' bold centered>
        {headerText}
      </Text>

      <Spacing paddingTop='giga'>
        <Text as='span' size='giga' noMargin centered>
          {blurbText}
        </Text>
      </Spacing>
      <Spacing paddingBottom='giga' paddingTop='giga'>
        <Image src={`${cdnUrl}user-profile.png`} naturalSize />
      </Spacing>
      <Spacing paddingBottom='yotta'>
        <Input
          type='text'
          value={username}
          submitUsername
          onChange={(e) => {
            setUsername(e.target.value.trim());
          }}
          onFocus={() => executeScroll()}
          validationHint={errorText}
          invalid={errorText.length > 0}
          maxLength='15'
          ref={inputRef}
        />
      </Spacing>
      <SubmitButton
        isLoading={isFetching}
        variant='primary'
        text={buttonText}
        stretch
        onSelect={handleUsernameSubmit}
      />
    </NameEntryContainer>
  );
};

export default NameEntry;
